export const formatDuration = (totalSeconds: number): string => {
	const seconds = Math.max(0, Math.floor(Number(totalSeconds) || 0))
	if (seconds === 0) return '0'
	if (seconds < 60) return `${seconds}s`
	const units = [
		{ label: 'y', secs: 31536000 },
		{ label: 'd', secs: 86400 },
		{ label: 'h', secs: 3600 },
		{ label: 'm', secs: 60 },
	]
	const parts: string[] = []
	let rest = seconds
	for (const unit of units) {
		const value = Math.floor(rest / unit.secs)
		if (value > 0) {
			parts.push(`${value}${unit.label}`)
			rest %= unit.secs
		}
		if (parts.length === 2) break
	}
	return parts.join(' ')
}
export default formatDuration
